import { Routes } from '@angular/router';
import { RegistrationIdentity } from './pages/registration-identity/registration-identity';
import { SuccessPage } from './pages/success-page/success-page';
export const routes: Routes = [
    {
        path: '', component: RegistrationIdentity
    },
    {
        path: 'register', component: RegistrationIdentity
    },
    {
        path: 'success', component: SuccessPage
    }
];
